import React, { useRef, useState } from 'react';
import styled from 'styled-components';
import { Select, TextInput as MatTextInput } from 'react-materialize';
import emailjs from 'emailjs-com';
import TextInput from '../atoms/textinput.jsx';
import Button from '../atoms/button.jsx';
import { Label } from '../atoms/label.jsx';
import Row from '../organism/row.jsx';
import Banner from '../organism/banner.jsx';
import LoadingSpinner from '../organism/spinner.jsx';
import { COLOR, SIZE, KEY, LABEL, FONT_FAMILY, SCREEN_MEDIA } from '../../utils/constants.js';

const Container = styled.div`
    overflow: auto; // To cover height with contents
    padding: 20px;
    @media only screen and ${SCREEN_MEDIA.small} {
        margin: 30px 20px;
    }
    @media only screen and ${SCREEN_MEDIA.medium} {
        margin: 30px 80px;
    }
    @media only screen and ${SCREEN_MEDIA.long} {
        margin: 30px 150px;
    }
    @media only screen and ${SCREEN_MEDIA.xlong} {
        margin: 30px 250px;
    }
`;

const FormCard = styled.div`
    overflow: auto; // To cover height with contents
    padding: 30px;
    background-color: ${COLOR.background};
    border-radius: 25px;
    -webkit-box-shadow: -1px 0px 22px -3px rgba(153,153,153,1);
    -moz-box-shadow: -1px 0px 22px -3px rgba(153,153,153,1);
    box-shadow: -1px 0px 22px -3px rgba(153,153,153,1);
`;

const StepContent = styled.div`
    display: ${props => props.active ? 'block' : 'none'};
`;

const BodyEventBooking = () => {

    const form = useRef();
    const [step, setStep] = useState(1);
    const [isSending, setIsSending] = useState(false);

    const goToStep2 = (e) => {
        e.preventDefault();
        setStep(2);
    };

    const goToStep1 = (e) => {
        e.preventDefault();
        setStep(1);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsSending(true);
        emailjs.sendForm(KEY.emailJsService, KEY.emailJsTemplate, form.current, KEY.emailJsUserId)
            .then(() => {
                setIsSending(false);
                window.M.toast({
                    html: '¡Solicitud de reserva enviada!',
                    classes: 'rounded green',
                    displayLength: 3000
                });
                form.current.reset();
                setStep(1);
            }, (error) => {
                console.log(error.text);
                setIsSending(false);
                window.M.toast({
                    html: 'Ocurrió un error al enviar tu reserva',
                    classes: 'red',
                    displayLength: 3000
                });
            });
    };

    if (isSending) return <LoadingSpinner/>;

    return (
        <div>
            <Banner title='Reserva tu evento'/>

            <Container>
                <Row>
                    <FormCard>
                        <Label
                            margin='0 0 30px 0'
                            text_size={SIZE.headline_top}
                            text_color={COLOR.ferra}
                            font_family={FONT_FAMILY.unicorns}>
                            { step === 1
                                ? 'Paso 1 de 2: Cuéntanos sobre tu evento'
                                : 'Paso 2 de 2: Confirma tu pago' }
                        </Label>

                        <form ref={form} onSubmit={handleSubmit}>

                            <StepContent active={step === 1}>
                                <Select
                                    id='eventType'
                                    name='eventType'
                                    multiple={false}
                                    noLayout
                                    onChange={ () => {} }
                                    options={{
                                        dropdownOptions: {
                                            closeOnClick: true
                                        }
                                    }}>
                                    <option value='' disabled selected>Tipo de evento</option>
                                    <option value='Cumpleaños'>Cumpleaños</option>
                                    <option value='Baby Shower'>Baby Shower</option>
                                    <option value='Ambiente romántico'>Ambiente romántico</option>
                                </Select>
                                <TextInput
                                    id='organizerName'
                                    name='organizerName'
                                    type='text'
                                    placeholder='Nombre del organizador'
                                    margin='30px 0'
                                    onChange={ () => {} }/>
                                <TextInput
                                    id='celebrantName'
                                    name='celebrantName'
                                    type='text'
                                    placeholder='Nombre del festejado (Opcional)'
                                    margin='30px 0'
                                    onChange={ () => {} }/>
                                <TextInput
                                    id='age'
                                    name='age'
                                    type='number'
                                    placeholder='Edad a cumplir (si aplica)'
                                    margin='30px 0'
                                    onChange={ () => {} }/>
                                <TextInput
                                    id='eventDate'
                                    name='eventDate'
                                    type='date'
                                    label='Fecha del evento'
                                    margin='30px 0'
                                    onChange={ () => {} }/>
                                <TextInput
                                    id='eventTime'
                                    name='eventTime'
                                    type='time'
                                    label='Hora del evento'
                                    margin='30px 0'
                                    onChange={ () => {} }/>
                                <TextInput
                                    id='address'
                                    name='address'
                                    type='text'
                                    placeholder='Dirección completa'
                                    margin='30px 0'
                                    onChange={ () => {} }/>
                                <TextInput
                                    id='phone'
                                    name='phone'
                                    type='tel'
                                    placeholder='Teléfono de contacto / WhatsApp'
                                    margin='30px 0'
                                    onChange={ () => {} }/>

                                <Button
                                    type='button'
                                    width='140px'
                                    height='46px'
                                    bg_color={ COLOR.primary }
                                    margin='10px 0 0 0'
                                    float='right'
                                    onClick={ goToStep2 }>
                                    <Label
                                        text_color={ COLOR.ferra }
                                        text_size={SIZE.subtitle}
                                        font_family={FONT_FAMILY.avenirMedium}
                                        margin='auto'>
                                        Siguiente
                                    </Label>
                                </Button>
                            </StepContent>

                            <StepContent active={step === 2}>
                                <Label
                                    margin='0 0 20px 0'
                                    text_size={SIZE.subtitle}
                                    text_color={COLOR.black}
                                    font_family={FONT_FAMILY.avenirMedium}>
                                    Adjunta la captura de pago
                                </Label>
                                <MatTextInput
                                    id='paymentScreenshot'
                                    name='paymentScreenshot'
                                    type='file'
                                    accept='image/png, image/jpeg'
                                    noLayout
                                    onChange={ () => {} }/>

                                <Button
                                    type='button'
                                    width='120px'
                                    height='46px'
                                    border_color={ COLOR.grayDark }
                                    text_color={ COLOR.grayDark }
                                    margin='30px 10px 0 0'
                                    float='left'
                                    onClick={ goToStep1 }>
                                    <Label
                                        text_color={ COLOR.grayDark }
                                        text_size={SIZE.subtitle}
                                        font_family={FONT_FAMILY.avenirMedium}
                                        margin='auto'>
                                        Atrás
                                    </Label>
                                </Button>
                                <Button
                                    type='submit'
                                    width='120px'
                                    height='46px'
                                    bg_color={ COLOR.primary }
                                    margin='30px 0 0 0'
                                    float='right'
                                    onChange={ () => {} }>
                                    <Label
                                        text_color={ COLOR.ferra }
                                        text_size={SIZE.subtitle}
                                        font_family={FONT_FAMILY.avenirMedium}
                                        margin='auto'>
                                        {LABEL.send}
                                    </Label>
                                </Button>
                            </StepContent>

                        </form>
                    </FormCard>
                </Row>
            </Container>
        </div>
    );
};

export default BodyEventBooking;
